module.exports = __webpack_public_path__ + "2ce8661f6da1d102b5b1a5e504bdb70f.svg";